import * as types from './constants';

// Get Assignment Summary
export const getAssignmentSummaryRequest = data => (
  { type: types.GET_ASSIGNMENT_SUMMARY_REQUEST, payload: data }
);

export const getAssignmentSummaryDone = data => (
  { type: types.GET_ASSIGNMENT_SUMMARY_DONE, payload: data }
);

export const getAssignmentSummaryFailed = errors => (
  { type: types.GET_ASSIGNMENT_SUMMARY_FAILED, payload: errors }
);